const TeamsIndexPage = () => import('@/pages/teams/TeamsIndexPage.vue')

export default [
  { path: "/teams", name: 'TeamsIndexPage', component: TeamsIndexPage },
]
